import { Flex, Hide, Spinner } from '@chakra-ui/react';

import { Header } from '../../components';
import { useGetCustomerCard, useGetUserInfo } from '../../hooks';

import { PaymentCreditCard } from './PaymentCreditCard';
import { PaymentMyProducts } from './PaymentMyProducts';

const ROOT_ENTITY = 'cross-seller/payment';

export const Payment = () => {
  const companyId = sessionStorage.getItem('companyId');
  const { isFindingUserInfo } = useGetUserInfo();
  const { isFindingCustomerCard } = useGetCustomerCard(companyId ?? '');
  const isFinding = isFindingUserInfo || isFindingCustomerCard;
  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 0, lg: 5 }}
      maxH="100dvh"
      h="100%"
    >
      <Header
        currentStep={2}
        rootEntity={ROOT_ENTITY}
        cart={<PaymentMyProducts />}
      />

      <Flex
        gap={5}
        flexDir={{ base: 'column', lg: 'row' }}
        p={{ base: 4, lg: 0 }}
      >
        <Flex flexDir="column" gap={6} w="full">
          {isFinding ? (
            <Flex
              w="full"
              h="calc(100vh - 100px)"
              justify="center"
              align="center"
            >
              <Spinner size="xl" color="brand.500" />
            </Flex>
          ) : (
            <PaymentCreditCard />
          )}
        </Flex>

        <Hide below="lg">
          <PaymentMyProducts />
        </Hide>
      </Flex>
    </Flex>
  );
};
